import React, { useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const StyleSelect = ({ setSelectedStyle, disabled }) => {
  const [styles, setStyles] = useState({
    apa: true,
    mla: false,
    chicago: false,
  });
  const { apa, mla, chicago } = styles;

  const handleChange = (event) => {
    const { name, checked } = event.target;

    // If unchecking the currently selected style, prevent unchecking
    if (!checked) {
      return;
    }

    // Update the selected style
    setStyles({
      apa: name === "apa" ? checked : false,
      mla: name === "mla" ? checked : false,
      chicago: name === "chicago" ? checked : false,
    });

    // Get the selected one based on the boolean values and set it
    const selectedStyle = checked ? name : null;

    setSelectedStyle(selectedStyle);
  };

  return (
    <FormControl sx={{ width: "100%" }} component="fieldset" variant="standard">
      <FormLabel component="legend">Citation Style</FormLabel>
      <FormGroup
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "0.6rem",
          alignItems: "center",
        }}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={apa}
              onChange={handleChange}
              name="apa"
            />
          }
          label="APA"
        />
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={mla}
              onChange={handleChange}
              name="mla"
            />
          }
          label="MLA"
        />
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={chicago}
              onChange={handleChange}
              name="chicago"
            />
          }
          label="Chicago"
        />
      </FormGroup>
    </FormControl>
  );
};

export default StyleSelect;
